import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const GitlabIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#000"
      d="m18.7 8.2-.02-.07-2.45-6.4a.64.64 0 0 0-.64-.4.7.7 0 0 0-.37.14q-.16.13-.21.33l-1.66 5.06h-6.7L5 1.8a.64.64 0 0 0-1.22-.07l-2.46 6.4-.02.06a4.55 4.55 0 0 0 1.51 5.26l.03.02 3.73 2.8 1.85 1.4 1.12.85a.8.8 0 0 0 .92 0l1.12-.85 1.85-1.4 3.75-2.81.01-.01a4.55 4.55 0 0 0 1.51-5.26"
    />
  </svg>
);
